import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Result } from '../main/shared/result';
import { environment } from '../../../src/environments/environment';
//import { Common } from '../../../src/utility/common';
import { map, first } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';


@Injectable({
  providedIn: 'root'
})
export class DatabindingService {

  constructor(private http: HttpClient) { }

  

  public GetAccessMenuPermission(data: any) {
    // return this.http.get<any>(`${environment.apiUrl}/Shared/AccessMenuPermission?MenuName=` + data);
    return this.http.get<any>(`${environment.apiUrl}/Shared/AccessMenuPermission?MenuName=` + data + '&UserId=' + localStorage.getItem("UserId"))
  }

  public GetUserSystemMappings(data: any) {
    // return this.http.get<any>(`${environment.apiUrl}/Shared/AccessMenuPermission?MenuName=` + data);
    return this.http.get<Result>(`${environment.apiUrl}/RoleManagement/GetUserSystemMappings?intUserId=` + data)
  }

  public GetStandardDateFormat() {
    return "dd-MM-yyyy HH:mm:ss";
  }
  public GetStandardDateOnlyFormat() {
    return "dd-MM-yyyy";
  }
  public GetDateOnlyFormat() {
    return "yyyy-MM-dd";
  }

  
}
